import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TitleBar from '../Layout/titleBar';
import MyDialog from '../Layout/myDialog';
import { Row, Col } from 'react-flexbox-grid';
import Item from './itemLocalidadEntrega';
import { sagaGetLocalidadesEntrega } from '../../reducers/localidadesEntregaReducer/actions';
import './localidadesEntrega.css';
import Pagination from '../Layout/pagination';

const LocalidadEntregaListado = (props) => {

    const [itemsLocalidades, setItemsLocalidades] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 24;

    React.useEffect(() => {
        const localidades = Array.isArray(props.localidades) ? props.localidades : [];
        setItemsLocalidades(localidades.map((x) => ({
            idLocalidadEntrega: x.idLocalidadEntrega,
            nombre: x.nombre,
            descripcion: x.descripcion,
            estado: x.estado,
            opciones: props.mapToItem(x).opciones,
        })));
        setCurrentPage(1);
    }, [props.localidades]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleSearch = (nombre) => {
        props.handleOnSearch(nombre);
        setCurrentPage(1);
    };

    // Elementos en página actual
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = itemsLocalidades.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <>
            <TitleBar
                title={'Localidades de Entrega'}
                handleOnSearch={handleSearch}
                searchPlaceholder="Buscar localidad..."
                showSearch={true}
                newButtonLink='/LocalidadesEntrega/Edit/0'
                validator="nombreynumeros"
            />

            <Row style={{ margin: '0px' }} className='draggable'>
                {currentItems && 
                    currentItems.map((item, index) => (
                        <Col md={6} lg={4} key={index} className='draggable'>
                            <Item item={item} {...props} />
                        </Col>
                    ))   
                }
            </Row>
            
            {(props.localidades === undefined || props.localidades.length === 0) && 
                <div className='noLocalidades'>No se encontraron localidades de entrega.</div>
            }

            {props.openModal &&
                <MyDialog
                    cuerpo={props.mensaje}
                    botonConfirmar={props.labelModalOk}
                    handleOnConfirmar={() => { props.handleModalOk(); setTimeout(props.handleOnSearch, 600); }}
                    handleOnCancelar={props.handleCloseModal}
                />
            }

            {/* Paginación */}
            { itemsLocalidades.length > itemsPerPage &&
                <Pagination
                    handleOnChange={handlePageChange}
                    page={currentPage}
                    totalPages={Math.ceil(itemsLocalidades.length / itemsPerPage)}
                />
            }
        </>
    );
};

LocalidadEntregaListado.propsTypes = {
    localidades: PropTypes.array.isRequired,
    handleOnSearch: PropTypes.func.isRequired,
    openModal: PropTypes.bool,
    mensaje: PropTypes.string,
    labelModalOk: PropTypes.string,
    handleModalOk: PropTypes.func,
    handleCloseModal: PropTypes.func,
};

LocalidadEntregaListado.defaultProps = {
    localidades: [],
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sagaGetLocalidadesEntrega,
    }, dispatch);
};

export default connect(null, mapDispatchToProps)(LocalidadEntregaListado);